const SgiCardEO = function () {
    return {
        cId: "",
        ctlN: "层叠面板",
        ctlH: '100%',
        ctlW: '100%',
        desId: "EP_EO_UI_4103",
        te: "",
        pad: "0 0 0 0",
        mgn: "0 0 0 0",
        // ctlN: "层叠面板",
        // isHdn: false,
        isBrdr: true,
        // flx: 6,
        // iconPh: "SD_RP_IR_0001`UI`UI05",
        // isBdyBrdr: true,
        // isBrdr: false,
        // isClp: false,
        // isClpFst: true,
        // isCls: false,
        // isDis: false,
        // isFrm: false,
        // isHClpTl: false,
        // clpDrt: "top",
        // clpd: false,
        // csstyle: "80",
        // isRead: false,
        // isScl: false,
        // isTtl: false,
        // isttlClp: false,
        // n: "视图类型层叠",
        // new_flag: true,
        // prmVsn: "0",
        // sNo: 2,
        // sc: "20171225090149727136",
        // ttlAlg: "top",
        // ttlAlgn: "left",
        // useTim: 0,
        // visible: true,
        // x: "0",
        // y: "0"
    }
}
export { SgiCardEO };
export default SgiCardEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiCardEO.js